import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../api/auth';
import { useAuth } from '../context/AuthContext';
import AuthNavbar from '../components/layout/AuthNavbar';

export default function CompleteRegistrationPage() {
  const [searchParams]              = useSearchParams();
  const token                       = searchParams.get('token') || '';
  const navigate                    = useNavigate();
  const { loginWithData }           = useAuth();

  const [password, setPassword]     = useState('');
  const [confirm, setConfirm]       = useState('');
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState('');
  const [success, setSuccess]       = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 8)  { setError('Password must be at least 8 characters.'); return; }
    setLoading(true);
    try {
      const data = await authApi.completeRegistration(token, password);
      setSuccess(true);
      if (data.accessToken) {
        loginWithData(data);
        setTimeout(() => navigate('/'), 1500);
      } else {
        setTimeout(() => navigate('/login'), 2500);
      }
    } catch (err) {
      setError(err.message || 'Registration failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <>
        <AuthNavbar />
        <div style={styles.bg}>
          <div style={styles.card}>
            <div style={styles.logo}>Inverow</div>
            <h1 style={styles.title}>Invalid link</h1>
            <p style={styles.sub}>This registration link is invalid or has expired.</p>
            <Link to="/register" style={styles.backLink}>Request a new link</Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <AuthNavbar />
      <div style={styles.bg}>
        <div style={styles.card}>
          <div style={styles.logo}>Inverow</div>

          {success ? (
            <>
              <div style={styles.successIcon}>✅</div>
              <h1 style={styles.title}>Account activated!</h1>
              <p style={styles.sub}>Your account is ready. Redirecting…</p>
            </>
          ) : (
            <>
              <h1 style={styles.title}>Set your password</h1>
              <p style={styles.sub}>Choose a strong password to activate your account.</p>

              {error && <div style={styles.error}>{error}</div>}

              <form onSubmit={handleSubmit} style={styles.form}>
                <label style={styles.label}>Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Min. 8 characters"
                  required
                  style={styles.input}
                  autoComplete="new-password"
                />

                <label style={styles.label}>Confirm password</label>
                <input
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder="••••••••"
                  required
                  style={styles.input}
                  autoComplete="new-password"
                />

                <button type="submit" disabled={loading} style={{ ...styles.btn, marginTop: '20px' }}>
                  {loading ? 'Activating…' : 'Activate account'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
}

const styles = {
  bg: { minHeight: 'calc(100vh - 71px)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: '24px' },
  card: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '20px', padding: '40px 36px', width: '100%', maxWidth: '420px', boxShadow: 'var(--shadow)' },
  logo: { fontSize: '22px', fontWeight: 800, color: 'var(--accent)', marginBottom: '24px', letterSpacing: '-0.5px' },
  title: { fontSize: '24px', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 6px' },
  sub: { fontSize: '14px', color: 'var(--text-secondary)', margin: '0 0 28px', lineHeight: 1.6 },
  successIcon: { fontSize: '40px', marginBottom: '16px' },
  error: { background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '10px', padding: '12px 14px', color: '#ef4444', fontSize: '14px', marginBottom: '20px' },
  form: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: 600, color: 'var(--text-secondary)', marginTop: '10px' },
  input: { padding: '12px 14px', borderRadius: '10px', border: '1px solid var(--border)', background: 'var(--surface-strong)', color: 'var(--text-primary)', fontSize: '15px', outline: 'none', boxSizing: 'border-box' },
  btn: { padding: '13px', borderRadius: '12px', border: 'none', background: '#6366f1', color: '#ffffff', fontSize: '15px', fontWeight: 700, cursor: 'pointer', width: '100%' },
  backLink: { display: 'inline-block', color: 'var(--accent)', textDecoration: 'none', fontSize: '14px', fontWeight: 600 },
};
